/**
 * All Business Portal Tours
 *
 * Aggregated array of every tour config for the business portal.
 */

import { controlCenterTour } from './control-center-tour';
import { documentsTour } from './documents-tour';
import { firstCaseTour } from './first-case-tour';
import { partnershipsTour } from './partnerships-tour';
import { pipelineTour } from './pipeline-tour';
import { prospectingTour } from './prospecting-tour';
import { reportsTour } from './reports-tour';
import { teamTour } from './team-tour';
import type { TourConfig } from './tour-config.types';
import { welcomeTour } from './welcome-tour';

export const allBusinessPortalTours: TourConfig[] = [
  welcomeTour,
  firstCaseTour,
  pipelineTour,
  teamTour,
  controlCenterTour,
  documentsTour,
  reportsTour,
  prospectingTour,
  partnershipsTour,
];
